"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const error_1 = __importDefault(require("~components/error"));
const NotFound = () => (0, jsx_runtime_1.jsx)(error_1.default, { message: "Oops, that page cannot be found." });
exports.default = NotFound;
